import React from 'react';
import { EventResponse, GuestWeddingResponse } from '../gds-api-client';

import { NewRSVPComponentProps } from './NewRSVPComponent';
import RSVPConfiguration, { RsvpConfigurationProps } from './RSVPConfiguration';

interface Props extends NewRSVPComponentProps, RsvpConfigurationProps {
  onSuccess: (data: GuestWeddingResponse, variant?: string) => void;
  onEventsUpdate: (events: EventResponse[], variant?: string) => void;
}

const RsvpSettings: React.FC<Props> = props => {
  return <RSVPConfiguration {...props} />;
};

export default RsvpSettings;
export { default as QuestionsRightRail } from './RSVPConfiguration/QuestionRightRail';
export { default as RSVPSettingsRightRail } from './RSVPSettingsRightRail';
export { default as RSVPSettings } from './RSVPSettingsRightRail/RsvpSettings';
export { default as EditInPreviewRsvpSettings } from './RSVPSettingsRightRail/EditInPreviewRsvpSettings';
